<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <span style="color:#2e2e2e">{{nav_name}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{nav_name}}</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <dl class="advice_tips" style="color: red">
              <dt>温馨提示</dt>
              <dd> 1、具有青海省户籍、持有残疾人证的低收入家庭中的残疾人，以及本人无固定经济收入且残疾等级被评定为一级、二级的残疾人可申请残疾人生活补贴。</dd>
              <dd>  2、具有青海省户籍，持有残疾人证且残疾等级被评定为一级、二级的残疾人可申请残疾人护理补贴；</dd>
              <dd> 3、此工具根据相关政策文件进行的粗略测算，测算金额不是实际办理结果。</dd>

            </dl>
            <el-form  :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
              <table width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab">
                <tr >
                  <td style="width: 202px;">
                    <el-form-item  label="受理单位" prop="selectedRegions">
                      <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择受理单位" clearable style="width: 200px;"></el-cascader>
                    </el-form-item>
                  </td>


                </tr>
                <tr>

                  <td>
                    <div style="width:390px;text-align: right;    padding-bottom: 21px;"><el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addDisCol">添加残疾信息</el-button><el-button  icon="el-icon-remove-outline" v-if="deleteDisable" @click="delDisCol">删除残疾信息</el-button></div>
                  </td>
                </tr>
                <tr  v-for="(items,index) in ruleForm.dis_info">
                  <td>
                    <el-form-item  :label="`残疾类型${index+1}`" :prop="`dis_info.${index}.dt_id`" :rules="[{ required: true, message: '请选择残疾类型',trigger: 'change'}]">
                      <el-select
                                 v-model="items.dt_id"
                                 collapse-tags
                                 placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dis_type"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                  </td>
                  <td>&nbsp;</td>
                  <td >
                    <el-form-item  :label="`残疾等级${index+1}`" :prop="`dis_info.${index}.dl_id`" :rules="[{ required: true, message: '请选择残疾等级',trigger: 'change'}]">
                      <el-select
                        v-model="items.dl_id"
                        collapse-tags

                        placeholder="请选择" style="width: 250px;">

                        <el-option
                          v-for="item in dis_level"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>

                <tr>
                  <td colspan="3"  >
                    <el-button :loading="loading" type="primary" @click="search" style=" width: 120px;
    margin-left: 100px;" :disabled="disableds">计算</el-button>

                  </td>
                </tr>

              </table>
            </el-form>
            <div v-if="totalShow" style="color: red;font-weight: 600;padding-left: 8%;padding-right: 8%;padding-top: 20px">
              预估你可以领取的残疾人护理补贴：{{total.hlfAmount}}元/月，残疾人生活补贴：{{total.livAmount}}元/月，具体以实际办理结果为准。

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers
    },

    data() {
      let _self=this;
      return {
        disableds:false,
        loading:false,
        totalShow:false,
        deleteDisable:false,
        selectedRegion:[],
        dis_info:[
          {
            dl_id:'',
            dt_id:'',
            dt_name:'',
            dis_info_id:'',
            dl_name:''
          }
        ],
        dis_type:[],dis_level:[],

        ruleForm:{
          // selecteddepartOption:[],
          theTitle:'',
          types:'',
          textarea:'',
          age:'',
          phone:'',

          dis_info:[
            {
              dl_id:'',
              dt_id:'',
              dt_name:'',
              dis_info_id:'',
              dl_name:''
            }
          ],
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          dt_id:[{required:true,message:'请选择残疾类型',tigger:'change'}],
          dl_id:[{required:true,message:'请选择残疾类型',tigger:'change'}],

        },



        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              //   if(node.value=='63010001'){
              //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
              //     resolve(nodes);
              //   }else{
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              //   }
              // }else{
              //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   // resolve(nodes);
              //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },

      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
      'ruleForm.dis_info'(n, o) {
        if (this.ruleForm.dis_info.length==1){
          this.deleteDisable=false;
        }else {
          this.deleteDisable=true;
        }
      },

    },
    created(){
      // this.showClause=true;
      // this.initClause();
      //建议类别枚举
      this.service_code=this.$route.query.service_code;
      this.nav_name=this.$route.query.nav_name;
      this.getDisData();


    },
    methods: {

      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.partyId=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.partyId="";
        }

      },

      getDisTypeLabel(a,b,c){
        if(c<=1){
          return a+"：";
        }else{
          return a+(b+1)+"";
        }
      },
      getDisLevelLabel(a,b,c){
        if(c<=1){
          return a+"：";
        }else{
          return a+(b+1)+"";
        }
      },
      search(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const options = {
              clp_data: this.ruleForm.dis_info,
              archive_type: 'CLP',
              part_id: this.partyId
            }
            this.totalShow = false;
            this.loading=true;
            this.$https.post("api/select/selectPaymentAmount.do", options, response => {
              if (response.status === 200 && response.data.code === 200) {
                this.totalShow = true;
                this.total = response.data.data;
              }
              this.loading=false;
            })
          }else {
            this.totalShow = false;
            this.loading=false;
            return
          }
        })
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },
      addDisCol(){
        if (this.ruleForm.dis_info.length<10){
          this.ruleForm.dis_info.push({
            dl_id:'',
            dt_id:'',
            dt_name:'',
            dis_info_id:'',
            dl_name:''
          });
        }else {
          this.$message.error('残疾信息过多！');
          return
        }

      },
      testClick(items){
        return items.dl_id;
      },
      testClick2(items){

        return items.dt_id;
      },
      delDisCol(){
        this.ruleForm.dis_info.pop();
      },
      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },
      //获取残疾类型和残疾等级数据
      getDisData(){
        let data={
        };
        var tt=this;
        this.$https.post('api/ywt/base/getDisData.do',data,response=>{
          if (response.data.code===200){
            tt.dis_type=response.data.data.disTypeList;
            tt.dis_level=response.data.data.disLevelList;
          }
        })
      },
      checkAge(rule, value, callback) {

        if (value<70) {
          return callback(new Error('请输入大于70的年龄！'))
        } else{
          callback()
        }
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },



    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/calculate/CLPCalculation.vue